<template>
  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div class="box-header">
      <div class="box-title">
        {{ $tc('most_read') }}
      </div>
      <div class="box-action">
        <FlotoLink v-if="mostReadArticles.length > 3" :to="viewAllLink">
          <MIcon name="view-more" size="2x" />
        </FlotoLink>
        <MIcon v-else name="file-read" size="2x" />
      </div>
    </div>
    <MDivider class="mt-1 my-4" />
    <MRow :gutter="0" class="flex-no-wrap flex-col min-w-0">
      <MCol
        v-for="(kb, index) in allMostReadArticles"
        :key="kb.id"
        class="flex-1 min-w-0 mb-4 flex flex-col"
      >
        <div class="flex min-w-0">
          <div class="kb-icon-conatiner">
            <MIcon name="calendar" size="2x" />
          </div>
          <div class="flex flex-1 flex-col min-w-0 mx-2">
            <FlotoLink
              :to="
                $currentModule.getRoute('read', {
                  params: { id: kb.id },
                })
              "
              class="item-name text-ellipsis min-w-0"
            >
              <span class="text-ellipsis">
                {{ kb.name }}: {{ kb.subject }}
              </span>
            </FlotoLink>
            <small
              class="flex justify-between item-creater text-ellipsis block"
            >
              {{ kb.createdTime | datetime }}
              <div
                class="text-primary folder-tag-bg rounded p-1 text-ellipsis"
                :title="kb.folderName"
              >
                {{ kb.folderName }}
              </div>
            </small>
          </div>
        </div>
      </MCol>
    </MRow>
  </div>
</template>

<script>
// import FolderPicker from '@modules/knowledge/components/folder-picker.vue'
export default {
  name: 'MostReadCard',
  // components: { FolderPicker },
  props: {
    mostReadArticles: { type: Array, required: true },
    viewAllLink: { type: Object, required: true },
  },
  computed: {
    allMostReadArticles() {
      return this.mostReadArticles.slice(0, 3)
    },
  },
}
</script>

<style lang="less" scoped>
.box-header {
  @apply flex justify-between items-center min-w-0;

  & .box-title {
    @apply flex pb-1;

    font-size: 0.898rem;
    font-weight: 500;
    color: var(--primary-alt);
  }

  & .box-action {
    color: var(--primary);
  }
}

.item-name {
  font-size: 12px;
  font-weight: 400;
  color: var(--page-text-color);
}

.item-creater {
  align-items: center;
  font-size: 11px;
  font-weight: 300;
  color: var(--neutral-regular);
}

.kb-icon-conatiner {
  @apply rounded items-center justify-center text-center flex;

  width: 41px;
  height: 41px;
  color: var(--primary-alt);
  background: rgba(50, 121, 190, 0.2);
}

.folder-tag-bg {
  max-width: 50%;
  font-weight: 400;
  background-color: rgba(0, 157, 220, 0.2);
}
</style>
